var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{activeRecording: _vm.isRecording},attrs:{"id":"VOICE","name":"VOICE","data-vcode":"VOICE","disabled":!_vm.isVoiceSupported,"aria-label":`${_vm.$t('voiceButton')}`}},[_c('img',{attrs:{"src":"/images/icons/voice.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('voiceButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }